module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/deluxe_mobile-30b28d7244456063129b0fb65895f2d6.webp";